import * as retail from "@/assets/img/applicationarea/retail.svg";
import * as office from "@/assets/img/applicationarea/office.svg";
import * as industry from "@/assets/img/applicationarea/industry.svg";
import * as outdoor from "@/assets/img/applicationarea/outdoor.svg";
import * as hospitality from "@/assets/img/applicationarea/hospitality.svg";

import * as suspendedPoint from "@/assets/img/archetypes/suspended_point.jpg";
import * as suspendedLinear from "@/assets/img/archetypes/suspended_linear.jpg";
import * as recessedPoint from "@/assets/img/archetypes/recessed_point.jpg";
import * as recessedLinear from "@/assets/img/archetypes/recessed_linear.jpg";
import * as surfaceMountedLinear from "@/assets/img/archetypes/surface_mounted_linear.jpg";
import * as wallMounted from "@/assets/img/archetypes/wall_mounted.jpg";
import * as freeStanding from "@/assets/img/archetypes/free_standing.jpg";
import * as downlight from "@/assets/img/archetypes/downlight.jpg";
import * as spotlight from "@/assets/img/archetypes/spotlight.jpg";
import * as highBayAndLowBay from "@/assets/img/archetypes/high-bay_and_low-bay.jpg";
import * as waterproof from "@/assets/img/archetypes/waterproof.jpg";
import * as cityAndStreet from "@/assets/img/archetypes/city_and_street.jpg";
import * as lampPosts from "@/assets/img/archetypes/lamp_posts.jpg";
import * as trunking from "@/assets/img/archetypes/trunking.jpg";
import * as tunnel from "@/assets/img/archetypes/tunnel.jpg";
import * as placeholder from "@/assets/img/140x140_placeholder_2.jpg";

const GuideImageMap = [
  {
    title: "Placeholder",
    image: placeholder
  },
  {
    title: "Retail",
    image: retail
  },
  {
    title: "Office",
    image: office
  },
  {
    title: "Industry",
    image: industry
  },
  {
    title: "Outdoor",
    image: outdoor
  },
  {
    title: "Hospitality",
    image: hospitality
  },
  {
    title: "Suspended Linear",
    image: suspendedLinear
  },
  {
    title: "Suspended Point",
    image: suspendedPoint
  },
  {
    title: "Recessed Linear",
    image: recessedLinear
  },
  {
    title: "Recessed Point",
    image: recessedPoint
  },
  {
    title: "Surface mounted Linear",
    image: surfaceMountedLinear
  },
  {
    title: "Wall mounted",
    image: wallMounted
  },
  {
    title: "Free standing",
    image: freeStanding
  },
  {
    title: "Downlight",
    image: downlight
  },
  {
    title: "Spotlight",
    image: spotlight
  },
  {
    title: "High-bay and Low-bay",
    image: highBayAndLowBay
  },
  {
    title: "Waterproof",
    image: waterproof
  },
  {
    title: "Tunnel",
    image: tunnel
  },
  {
    title: "Lamp posts",
    image: lampPosts
  },
  {
    title: "City and Street",
    image: cityAndStreet
  },
  {
    title: "Trunking",
    image: trunking
  }
];

export default GuideImageMap;
